import React, { useState } from 'react';
import logo from './images/logo BMG 2020.png';
import './App.css';
import { BarStyle, HorizontalSpaceContainer, ImageStyle, SteelImage, SteelImageStyle, StyledButton, Title, UnitBox, UnitContainer } from './components/visual';
import { DetailCalc, Dropdown, InputField, inputInfo, InputsDisplay } from './components/usefulComponents';
import { AllUnits, Geometry, Materials, ShapeProps } from './components/shapeMetalList';
import { MetalData } from './data/MetalData';
const metalData: MetalData = require('./data/localization.json');

export type Inputs = Partial<MetalData[0]>
export type InputVariable = keyof Inputs

export var inputArray: inputInfo[] = [];
// Rememebr that X_1 means metric system
function App() {
  const [shape, setShape] = useState(Geometry.Shapes[0]);
  const [unit, setUnit] = useState(AllUnits.dimensional[0]);
  //const [metal, setMetal] = useState(Materials.Metals[0]); old metal selector (leave just in case :p)
  const metal = Materials.Metals[0];
  const [inputs, setInputs] = useState<Inputs>({});
  const [length, setLength] = useState("");

  var customMetal = {
    customName: '',
    mass: ''
  };
  if (shape.Abreviation === "PL") {
    if (inputs.W && length && inputs.t) {
      let W = parseFloat(inputs.W);
      let L = parseFloat(length);
      let t = parseFloat(inputs.t);
      let d = metal.Density;
      if (unit.DocConvert === '') {
        d = d * .0000361273;
        L = L * 12
      } else {
        d = d * .000000001;
        L = L * 1000
      }
      let mass = d * (W * L * t);
      customMetal.customName = "PL" + W + "X" + length + "X" + t;
      customMetal.mass = mass.toLocaleString('en-US');
    }
  };
  //Filtering
  let result = metalData.filter(metal => metal.Type === shape.Abreviation)
  for (let variable of shape.UniqueDimensions) {
    let metalVariable = variable;
    if (unit.DocConvert === "_1") {
      metalVariable = (variable + unit.DocConvert) as InputVariable;
    }
    const input = inputs[variable as InputVariable]
    if (input == null || input.length === 0) continue
    result = result.filter(metal => parseFloat(metal[metalVariable]) < parseFloat(input) * 1.03 && parseFloat(metal[metalVariable]) > parseFloat(input) * .97)
    console.log(inputs);
  }
  inputArray = []; //What code does to an mf
  function clearInputsOnChange(newShape: ShapeProps) {
    setInputs({});
    setLength('');
    setShape(newShape);
  }
  const [open, setOpen] = useState<string>('');
  //<BarStyle><ImageStyle src={logo} /></BarStyle>
  return (
    <div className="App">

      <SteelImage><SteelImageStyle src={shape.Image} /></SteelImage>
      <br />
      <HorizontalSpaceContainer>
        <Dropdown object={shape} setObject={clearInputsOnChange} />
        <Dropdown object={unit} setObject={setUnit} />
      </HorizontalSpaceContainer>
      <br />
      <InputsDisplay dimensions={shape.UniqueDimensions} inputs={inputs} setInputs={setInputs} unit={unit} shape={shape} />
      <UnitContainer>
        <InputField variable={"L"} value={length} onChange={setLength} />
        <UnitBox>
          {(unit.DocConvert === "_1") ? "m" : "ft"}
        </UnitBox>
      </UnitContainer>
      <br />
      <br />

      <Title>
        {(shape.Abreviation === "PL") ? "Calculated Metal Estimate" : "Availible Metals"}:
      </Title>

      {(customMetal.mass !== "") && (
        <div>
          <StyledButton onClick={() => setOpen((open === customMetal.mass) ? '' : customMetal.mass)}>
            {customMetal.customName} ({customMetal.mass}{unit.Mass})
          </StyledButton>
          {(open === customMetal.mass) && (
            <div>
              <DetailCalc weight={parseFloat(customMetal.mass)} unit={unit.Mass} />
              <br />
              <br />
            </div>
          )}
        </div>
      )}

      {!(Object.values(inputs).every(item => item == '') && length == "") && result.map((r, i) =>
        <div key={i}>
          <StyledButton onClick={() => setOpen((open === r.W) ? '' : r.W)}>
            {(unit.DocConvert === "") ? r.AISC_Manual_Label : r.AISC_Manual_Label_1} ({(unit.DocConvert === "") ? r.W : r.W_1}{unit.Mass}/{unit.BigDimensions})
          </StyledButton>
          {(open === r.W) && (
            <div>
              <DetailCalc weight={parseFloat(r.W) * parseFloat(length)} unit={unit.Mass} />
              <br />
              <br />
            </div>
          )}
        </div>
      )}

    </div>
  );
}
// <Dropdown object = {metal} setObject = {setMetal}/> only 1 metal is used

export default App;
